import React, { FC, ReactNode } from 'react';

import { useFeatureFlagContext } from 'Contexts/featureFlagContext';

import { PageLayoutContainer as PageLayoutContainerOld } from './styled';
import { PageLayoutContainer2025 } from './styled2025';

export interface PageLayoutProps {
  size?: 'normal' | 'small';
  bg?: string;
  page?: string;
  id?: string;
  children?: ReactNode;
}

export const PageLayout: FC<PageLayoutProps> = ({
  size = 'normal',
  bg = '',
  page,
  id,
  children,
}: PageLayoutProps) => {
  const { is_ulp_updates_enabled } = useFeatureFlagContext();
  const PageLayoutContainer = is_ulp_updates_enabled ? PageLayoutContainer2025 : PageLayoutContainerOld;
  return (
    <PageLayoutContainer id={id} size={size} bg={bg} page={page}>
      <section className="inner-wrapper">{children}</section>
    </PageLayoutContainer>
  );
};
